import React, { Component } from "react";
import { Row, Col, Calendar, Button, Modal, Input, Icon, Divider } from "antd";
import moment from "moment";
import _ from "underscore";
import { app } from "../../app";
import api from "../../api";
import sign_rl_icon from "../../assets/sign_rl_icon.png";
import help from "../../assets/help.png";
import Rule from "../../components/Rule";

class UserSign extends Component {
  constructor(props) {
    super(props);
    this.state = {
      signData: [],
      recordData: [],
      currentTime: moment(),
      selectDate: moment(),
      continuity: 0,
      aggregatescore: 0,
      integral_total_status:0,
      detail_visible: false,
    };
  }

  async componentDidMount() {
    this._isMounted = true;
    console.log(moment().daysInMonth());
    await this.handleSignData();
    // await this.handleSignIntegralData()
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  setData = (data) => app.setStateSync(this, data);

  /**
   * 获取签到数据
   * @returns {Promise<void>}
   */
  handleSignData = async (date) => {
    await app.alert("正在加载~", "loading");
    let params = {
      indexno: app.getData("indexno"),
      account: app.getData("account"),
    };
    if (date) params.date = date.format("YYYY-MM");
    let { flag, data,integral_total_status, msg, time } = await app.post(
      api.SinginSinginList,
      params
    );
    if (flag !== 1) {
      app.alert(msg, "warn");
      data = [];
    }
    await this.setData({
      aggregatescore: data.integral_total,
      continuity: data.integral_today,
      signData: data.singin_list,
      integral_total_status:integral_total_status,
      currentTime: moment(time),
      selectDate: date || moment(time),
    });
    app.alertDestroy();
  };

  /**
   * 领取
   * @returns {Promise<void>}
   */
  handleGet = async (id) => {
    await app.alert("正在加载~", "loading");
    let params = {
        id,
        indexno: app.getData("indexno"),
        account: app.getData("account"),
      },
      { flag, msg } = await app.post(api.SinginGetIntegral, params);
    if (flag === 1) {
      app.alert("领取成功", "success");
      await this.handleSignIntegralData();
    } else {
      app.alert(msg, "warn");
    }
    app.alertDestroy();
  };

  /**
   * 签到
   * @returns {Promise<void>}
   */
  handleSign = async () => {
    await this.setData({ sign_loading: true });
    let params = {
        indexno: app.getData("indexno"),
        account: app.getData("account"),
      },
      { flag, data, msg } = await app.post(api.SinginAffirmSingin, params);
    if (flag === 1) {
      if (data.status === "1") {
        app.alert("签到成功", "success");
        await this.handleSignData(this.state.currentTime);
        // await this.handleSignIntegralData()
      } else {
        Modal.confirm({
          title:
            data.type === "1"
              ? `您今天还有${data.list.length}条通知未阅读`
              : `您今天还有${data.list.length}支队伍的工作报表未上传`,
          icon: <Icon type="info-circle" />,
          width: "50%",
          content: (
            <ol>
              {(data.list || []).map((t, i) => {
                return (
                  <li
                    key={i}
                    style={{
                      marginTop: 10,
                      fontSize: "1rem",
                      wordBreak: "breakWord",
                    }}
                  >
                    {t.title}
                  </li>
                );
              })}
            </ol>
          ),
          centered: true,
          okText: "前往",
          cancelText: "取消",
          onOk: () => {
            console.log(this.props.history);
            if (data.type === "1") {
              this.props.history.push("/notice/list");
            } else {
              this.props.history.push("/ranks/report");
            }
          },
        });
      }
    } else {
      app.alert(msg, "warn");
    }
    await this.setData({ sign_loading: false });
  };

  /**
   * 请假
   * @returns {Promise<void>}
   */
  handleQingJia = () => {
    let leave_reason = "",
      qingjia_loading = false;
    Modal.confirm({
      title: "请假原因",
      okText: "确定",
      cancelText: "取消",
      content: (
        <Input.TextArea
          onChange={(e) => {
            leave_reason = e.target.value;
          }}
        />
      ),
      centered: true,
      onOk: async () => {
        qingjia_loading = true;
        let params = {
            leave_reason,
            indexno: app.getData("indexno"),
            account: app.getData("account"),
          },
          { flag, msg } = await app.post(api.SinginAffirmLeave, params);
        if (flag === 1) {
          app.alert("请假成功", "success");
          qingjia_loading = false;
          await this.handleSignData(this.state.currentTime);
        } else {
          app.alert(msg, "warn");
        }
      },
    });
  };

  /**
   * 获取签到积分数据
   * @returns {Promise<void>}
   */
  handleSignIntegralData = async () => {
    let params = {
        indexno: app.getData("indexno"),
        account: app.getData("account"),
      },
      { flag, data, msg, day } = await app.post(api.SinginIntegralList, params);
    if (flag !== 1) {
      app.alert(msg, "warn");
      data = [];
    }
    await this.setData({ recordData: data, continuity: day || 0 });
  };

  /**
   * 显示请假原因
   * @param reason
   */
  handleShowLeaveReason = (reason) => {
    Modal.info({
      title: "请假原因",
      content: reason,
      okText: "确定",
      centered: true,
    });
  };

  /**
   * 打开详情
   */
  handleOpenDetail = async () => {
    await this.setData({ detail_visible: true, detail_loading: true });
    let state = { detail_loading: false };
    let { flag, data, msg } = await app.post(api.personalCenterContent, {
      area_id: 0,
      about_name: "积分规则",
    });
    if (flag === 1) {
      state.detail_data = data;
    } else {
      app.alert(msg, "error");
    }
    await this.setData(state);
  };

  /**
   * 关闭详情
   */
  handleCancelDetail = () => {
    this.setData({ detail_visible: false });
  };

  handleClick = () => {
    this.props.history.push("/player/integral");
  };

  /**
   * 日期单元格样式
   * @param date
   * @returns {*}
   */
  handleFullDateRender = (date) => {
    let { signData, currentTime, selectDate } = this.state,
      days = date.daysInMonth(),
      dateStr = date.format("YYYY-MM-DD"),
      dayStr = date.format("DD");
    if (!selectDate.isSame(date, "month")) {
      return "";
    } else {
      let data = _.find(
        signData,
        (d) => dateStr === moment(d.singin_time).format("YYYY-MM-DD")
      );
      if (data) {
        if (data.is_leave === "1") {
          return (
            <div
              className="sic-item sici-no"
              onClick={() => this.handleShowLeaveReason(data.leave_reason)}
            >
              <div className="sid-day">{dayStr}</div>
              <div className="sid-text">已请假</div>
            </div>
          );
        } else {
          return (
            <div className="sic-item sici-yes" style={{ cursor: "pointer" }}>
              <div className="sid-day">{dayStr}</div>
              <div className="sid-text">已签到</div>
            </div>
          );
        }
      } else if (date.isBefore(moment(currentTime).add(1, "d"), "day")) {
        return (
          <div className="sic-item sici-no">
            <div className="sid-day">{dayStr}</div>
            <div className="sid-text">未签到</div>
          </div>
        );
      } else {
        return (
          <div className="sic-item sici-not">
            <div className="sid-day">{dayStr}</div>
          </div>
        );
      }
    }
  };

  render() {
    let {
      currentTime,
      continuity,
      aggregatescore,
      recordData,
      sign_loading,
      qingjia_loading,
      detail_loading,
      detail_data,
      integral_total_status,
      detail_visible,
    } = this.state;
    return (
      <div className="sign-index">
        <div className="si-title">签到</div>
        <div className="si-content">
          <Calendar
            validRange={[moment("2018-01-01"), currentTime]}
            defaultValue={currentTime}
            dateFullCellRender={this.handleFullDateRender}
            onPanelChange={this.handleSignData}
          />
          <div className="sic-info">
            <Row type="flex" justify="space-between" align="middle">
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  cursor: "pointer",
                  width:'100px'
                }}
              >
                 {/* {integral_total_status === 1 && (
                  <div onClick={this.handleClick}>
                    {" "}
                    <div  className="sici-title">
                      总积分
                    </div>
                    <div style={{ fontSize: "28px", fontWeight: "bold" }}>
                      {aggregatescore}
                    </div>
                  </div>
                )} */}
                <div onClick={this.handleClick}>
                    {" "}
                    <div  className="sici-title">
                      总积分
                    </div>
                    <div style={{ fontSize: "28px", fontWeight: "bold" }}>
                      {aggregatescore}
                    </div>
                  </div>
              </div>
              {/* <Button type="danger" size="large" loading={qingjia_loading}
                                    onClick={this.handleQingJia}>请假</Button> */}
              <div className="sici-title">今日积分</div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "30px",
                  }}
                  onClick={this.handleOpenDetail}
                >
                  <img
                    style={{
                      width: "18px",
                      height: "18px",
                      marginRight: "5px",
                    }}
                    src={help}
                  ></img>
                  积分规则
                </div>
                <Button
                  type="primary"
                  size="large"
                  loading={sign_loading}
                  onClick={this.handleSign}
                >
                  签到
                </Button>{" "}
              </div>
            </Row>
            <div className="sici-icon">
              <img src={sign_rl_icon} alt="" />
              <div className="sicii-day">
                {continuity ? "+" + continuity : continuity} 分
              </div>
            </div>
          </div>
          <Modal
            visible={detail_visible}
            footer={null}
            title="积分规则"
            maskClosable={false}
            width="100%"
            style={{ top: 0, height: "100vh" }}
            bodyStyle={{ height: "calc(100vh - 55px)", overflow: "auto" }}
            onCancel={this.handleCancelDetail}
            zIndex={9999}
            className="news-detail-modal-class"
          >
            <Rule data={detail_data} loading={detail_loading} />
          </Modal>
        </div>
      </div>
    );
  }
}

export default UserSign;



// WEBPACK FOOTER //
// ./src/routes/sign/UserSign.jsx